export default "__VITE_ASSET__CfFXgc0A__"